import { $http } from '@tajawal/web-core-sdk-v2/lib/services/http.service';
import _toUpper from 'lodash/toUpper';
import { ENDPOINTS } from "../constants/index.js";
export var LoyaltyClient = {
  /**
   * calculate fursan points for multiple packages
   * @param {Object} payload
   * @return {Promise}
   */
  calculateFursanBulkRewards: function calculateFursanBulkRewards(payload) {
    var requestId = 'CALCULATE_FURSAN_REWARD_BULK';
    var endPoint = ENDPOINTS.CALCULATE_REWARD_BULK;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  /**
   * calculate fursan points for a single package
   * @param {Object} payload
   * @return {Promise}
   */
  calculateFursanRewards: function calculateFursanRewards(payload) {
    var requestId = 'CALCULATE_FURSAN_REWARD';
    var endPoint = ENDPOINTS.CALCULATE_REWARD;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  /**
   * calculate qitaf points for multiple packages
   * @param {Object} payload
   * @return {Promise}
   */
  calculateQitafBulkRewards: function calculateQitafBulkRewards(payload) {
    var requestId = 'CALCULATE_QITAF_REWARD_BULK';
    var endPoint = ENDPOINTS.CALCULATE_REWARD_BULK;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  },
  /**
   * calculate qitaf points for a single package
   * @param {Object} payload
   * @return {Promise}
   */
  calculateQitafRewards: function calculateQitafRewards(payload) {
    var requestId = 'CALCULATE_QITAF_REWARD';
    var endPoint = ENDPOINTS.CALCULATE_REWARD;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  /**
   * calculate mokafaa points for a single package
   * @param {Object} payload
   * @return {Promise}
   */
  calculateMokafaaRewards: function calculateMokafaaRewards(payload) {
    var requestId = 'CALCULATE_MOKAFA_REWARD';
    var endPoint = ENDPOINTS.CALCULATE_REWARD;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  },
  /**
   * calculate bulk points for multiple loyalty
   * @param {Object} payload
   * @param {String} payload
   * @return {Promise}
   */
  calculateBulkLoyaltyRewards: function calculateBulkLoyaltyRewards(payload, method) {
    var requestId = "CALCULATE_" + _toUpper(method) + "_REWARD_BULK";
    var endPoint = ENDPOINTS.CALCULATE_REWARD_BULK;
    return $http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  }
};